import React from 'react';
import { Table, Button, List } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

import countries from './AmazonCountries';

import 'react-lazy-load-image-component/src/effects/blur.css';

class SingleProductView extends React.Component {
    searchAlternatives = item => {
        const country = this.props.country;
        const name = item.name;
        const allowedMaxLength = 8;
        const query = name.split(' ').filter((n, i, a) => i < allowedMaxLength).map(c => encodeURIComponent(c)).join('+');
        const siteUrl = countries[country].storeUrl;
        return window.open(`${siteUrl}/s?k=${query}`, '_blank');
    }

    getColumns = () => {
        const { record } = this.props;
        return [
            {
                title: 'Page',
                key: 'page',
                dataIndex: 'page',
                render: (item, record) => {
                    return (
                        <a href={record.page} target="_blank" rel="noopener noreferrer">
                            {record.page}
                        </a>
                    );
                }
            },
            {
                title: 'Anchor Text',
                key: 'anchor',
                dataIndex: 'anchor',
                className: 'anchor-text-table-column'
            },
            {
                title: 'Affiliate Id',
                key: 'affiliateId',
                dataIndex: 'affiliateId',
                render: (one, two) => {
                    if (Boolean(record.affiliateId)) return record.affiliateId;
                    return two.affiliateId && two.affiliateId.length > 0 ? two.affiliateId : 'None';
                }
            }
        ];
    }

    renderNoAnchorProduct = () => {
        const { record, country, exportSingleProduct, isDemo } = this.props;
        const data = record.from;
        return (
            <List
                size="small"
                header={<div>Pages</div>}
                footer={
                    <Button
                        type="primary"
                        disabled={isDemo}
                        icon={<DownloadOutlined />}
                        size="small"
                        onClick={() => exportSingleProduct(record)}
                    >
                        Export
					</Button>
                }
                bordered
                dataSource={data}
                renderItem={(item) => (
                    <List.Item>
                        <a href={item} target="_blank" rel="noopener noreferrer">
                            {item}
                        </a>
                    </List.Item>
                )}
            />
        );
    }

    render() {
        const { record, country, exportSingleProduct, isDemo } = this.props;
        const data = record.from;
        if (data && data[0] && !data[0].page) return this.renderNoAnchorProduct();

        return (
            <div className="site-report-nested-table-container">
                <Table
                    style={{ margin: 0 }}
                    header={() => <div>Pages</div>}
                    // footer={() => (
                    //     <Button
                    //         type="primary"
                    //         disabled={isDemo}
                    //         icon={<DownloadOutlined />}
                    //         size="small"
                    //         onClick={() => exportSingleProduct(record)}
                    //     >
                    //         Export
                    //     </Button>
                    // )}
                    size="small"
                    columns={this.getColumns()}
                    dataSource={data}
                    bordered
                    pagination={{ hideOnSinglePage: true, pageSize: 40 }}
                    rowKey={(item, index) => `${item.page}${item.anchor}-${index}`}
                />
            </div>
        );
    }
}

export default SingleProductView;
